import { ApiErrorHandlerConstants } from './apiErrorHandler.constants'
import { IApiErrorHandlerAction, IApiErrorHandlerState } from './apiErrorHandler.types'

export const initialApiErrorHandlerState: IApiErrorHandlerState = {
  error: null,
  showAlert: false,
  showToast: false,
  callback: undefined,
  errorMessage: '',
  buttons: null,
  header: null,
  errorToastDuration: null,
}

export function apiErrorHandlerReducer(
  state: IApiErrorHandlerState = initialApiErrorHandlerState,
  action: IApiErrorHandlerAction
): IApiErrorHandlerState {
  switch (action.type) {
    case ApiErrorHandlerConstants.SHOW_ALERT:
      return { ...state, showAlert: action.showAlert }
    case ApiErrorHandlerConstants.SHOW_TOAST:
      return { ...state, showToast: action.showToast }
    case ApiErrorHandlerConstants.HANDLE_API_ERROR:
      return { ...state, error: action.error }
    case ApiErrorHandlerConstants.SET_ERROR_MESSAGE:
      return { ...state, errorMessage: action.errorMessage }
    case ApiErrorHandlerConstants.SET_ERROR_TOAST_DURATION:
      return { ...state, errorToastDuration: action.errorToastDuration }
    case ApiErrorHandlerConstants.RESET_API_ERROR_HANDLER:
      return { ...initialApiErrorHandlerState }
    case ApiErrorHandlerConstants.SET_CALLBACK:
      return { ...state, callback: action.callback }
    case ApiErrorHandlerConstants.SET_BUTTONS:
      return { ...state, buttons: action.buttons }
    case ApiErrorHandlerConstants.SET_HEADER:
      return { ...state, header: action.header }
    default:
      return state
  }
}
